import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useRef } from 'react';
import { AssetSearchBarStyles } from 'components/AssetSearchBar/AssetSearchBarStyles';

const SPLIT_PATTERN = /[\n\r,\t]+/;

const WoRoSearchBar = ({ woRoTerms = [], onWoRoTermsChange }) => {
    const classes = AssetSearchBarStyles();
    const inputRef = useRef();

    const applyTerms = (incoming) => {
        const cleaned = incoming.map(t => t.trim()).filter(Boolean);
        onWoRoTermsChange([...new Set([...woRoTerms, ...cleaned])]);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('Text');
        applyTerms(text.split(SPLIT_PATTERN));
        if (inputRef.current) inputRef.current.blur();
    };

    return (
        <Autocomplete
            multiple
            freeSolo
            filterSelectedOptions
            options={[]}
            value={woRoTerms}
            onChange={(_, newValue) => {
                const cleaned = newValue.map(t => t.trim()).filter(Boolean);
                onWoRoTermsChange([...new Set(cleaned)]);
            }}
            className={classes.autoComplete}
            sx={{
                margin: 0,
                '& .MuiInputBase-root': {
                    minHeight: '30px',
                    padding: '0px 8px !important',
                },
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    placeholder={woRoTerms.length ? '' : 'Search or Paste a List of WO/RO Numbers'}
                    inputRef={inputRef}
                    onPaste={handlePaste}
                />
            )}
        />
    );
};

export default WoRoSearchBar;
